import { useEffect } from "react";
import { useAuth } from "@clerk/clerk-react";
import { setClerkTokenGetter } from "../authToken";

/** Bridges Clerk session tokens into api.js. */
export default function ClerkTokenBridge() {
  const { getToken, isSignedIn } = useAuth();

  useEffect(() => {
    setClerkTokenGetter(async () => {
      if (!isSignedIn) return null;
      return getToken();
    });
    return () => setClerkTokenGetter(null);
  }, [getToken, isSignedIn]);

  return null;
}
